import {
  Modal,
  ProgressIndicator,
  ProgressStep,
} from 'carbon-components-react';
import React, { useState, useEffect } from 'react';
import Step1 from '../../Molecules/Steps/Step1';
import Step3 from '../../Molecules/Steps/Step3';
import Step5 from '../../Molecules/Steps/Step5';
import Step6 from '../../Molecules/Steps/Step6';
import Step7 from '../../Molecules/Steps/Step7';
import Step8 from '../../Molecules/Steps/Step8';
import { QuesIDProps, que8ValueProps } from '../../Maas360Estimator';
import { Restart20 } from '@carbon/icons-react';
import Selection from '../../Molecules/Selection/Selection';
import Result from '../../Molecules/Result/Result';
import TopMatch from '../../Molecules/TopMatch/TopMatch';
import {
  additionOption,
  aws,
  DELUX_MATCH,
  DEVICE_THRESHOLD_AWS,
  MaaS360,
  marketplaceUrl,
} from '../../../constants/default';
import Switcher from '../../Molecules/Switcher/Switcher';
import usePrice from 'src/apps/maas360-estimator/hooks/usePrice';
import { segmentsTracking } from 'src/common/lib/tracker';
import { useCookiesURL } from 'src/common/hooks/widgets/useCookiesURL';
import { useSetCookie } from 'src/apps/maas360-estimator/hooks/useSetCookie';
import BusinessPartner from 'src/common/components/BusinessPartner/BusinessPartner';
import { useSmallBreakpoint } from 'src/common/hooks/widgets/useBreakpoint';
import Step2 from '../../Molecules/Steps/Step2';
import Step4 from '../../Molecules/Steps/Step4';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';
import { convertToString } from 'src/apps/maas360-estimator/lib/utils';
import { WindowOpenFunction } from 'src/common/hooks/widgets/useLang';

type PopUpModalProps = {
  langCode: string;
  bpName: string;
  logo: string;
  companyId: string;
  open: boolean;
  handleCloseModal: () => void;
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  currentQuestion: string;
  setCurrentQuestion: React.Dispatch<React.SetStateAction<string>>;
  isRequired: boolean;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  que1Value: string;
  setQue1Value: React.Dispatch<React.SetStateAction<string>>;
  que2Value: string;
  setQue2Value: React.Dispatch<React.SetStateAction<string>>;
  que3Value: string;
  setQue3Value: React.Dispatch<React.SetStateAction<string>>;
  que4Value: string;
  setQue4Value: React.Dispatch<React.SetStateAction<string>>;
  que5Value: string;
  setQue5Value: React.Dispatch<React.SetStateAction<string>>;
  que6Value: string;
  setQue6Value: React.Dispatch<React.SetStateAction<string>>;
  que7Value: number;
  setQue7Value: React.Dispatch<React.SetStateAction<number>>;
  que8Value: que8ValueProps;
  setQue8Value: React.Dispatch<React.SetStateAction<que8ValueProps>>;
  trackQuesID: QuesIDProps;
  setTrackQuesID: React.Dispatch<React.SetStateAction<QuesIDProps>>;
  topMatch: string;
  setTopMatch: React.Dispatch<React.SetStateAction<string>>;
  showTopMatch: boolean;
  setShowTopMatch: React.Dispatch<React.SetStateAction<boolean>>;
  noAdditionalReq: boolean;
  setNoAdditionalReq: React.Dispatch<React.SetStateAction<boolean>>;
  deluxe: boolean;
  formComplete: boolean;
  setDeluxe: React.Dispatch<React.SetStateAction<boolean>>;
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setModel2: React.Dispatch<React.SetStateAction<boolean>>;
  setFormComplete: React.Dispatch<React.SetStateAction<boolean>>;
  setTopMatchDetails: React.Dispatch<React.SetStateAction<topMatchProps>>;
  handleUrxForm: () => void;
  topMatchDetails: topMatchProps;
  model2: boolean;
  localeCode: string;
  reset: () => void;
  currency: string;
  country: string;
  useTranslation: TranslationFunction;
  windowOpen: WindowOpenFunction;
};

export type topMatchProps = {
  title: string;
  plan: string;
  shortDesc: string;
  desc: string;
  icon: string;
  price: string;
  url: string;
  signUpUrl: string;
};

export type deluxeProps = {
  title: string;
  plan: string;
  shortDesc: string;
  icon: string;
  price: string;
  url: string;
};

const deluxeState = {
  title: '',
  plan: '',
  shortDesc: '',
  icon: '',
  price: '',
  url: '',
};

const Assessment = ({
  open,
  handleCloseModal,
  step,
  que3Value,
  setQue3Value,
  que5Value,
  setQue5Value,
  setStep,
  isRequired,
  setIsRequired,
  que6Value,
  setQue6Value,
  que7Value,
  setQue7Value,
  que8Value,
  setQue8Value,
  trackQuesID,
  setTrackQuesID,
  setTopMatch,
  topMatch,
  setShowTopMatch,
  deluxe,
  setDeluxe,
  topMatchDetails,
  setTopMatchDetails,
  localeCode,
  reset,
  currency,
  country,
  bpName,
  logo,
  handleUrxForm,
  que1Value,
  setQue1Value,
  que2Value,
  setQue2Value,
  que4Value,
  setQue4Value,
  useTranslation,
  windowOpen,
}: PopUpModalProps) => {
  const [deluxeData, setDeluxeData] = useState<deluxeProps>(deluxeState);
  const [deluxePkg, setDeluxePkg] = useState(false);
  const [plan, setPlan] = useState('');
  const [packageOption, setPackageOption] = useState(topMatch);
  const cookieURL = useCookiesURL();
  const [enterprisePrice, deluxePrice, premierPrice, essentialPrice] = usePrice(
    { localeCode, currency, country },
  );

  const [invalidQ1, setInvalidQ1] = useState(false);
  const [invalidQ2, setInvalidQ2] = useState(false);
  const [invalidQ3, setInvalidQ3] = useState(false);
  const [invalidQ4, setInvalidQ4] = useState(false);
  const [invalidQ5, setInvalidQ5] = useState(false);
  const [invalidQ6, setInvalidQ6] = useState(false);
  const [invalidQ7, setInvalidQ7] = useState(false);
  const [invalidQ8, setInvalidQ8] = useState(false);

  const isSmall = useSmallBreakpoint('768px');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const checkQ8Value = (options: any) => {
    const selectedItems = options?.multi?.selectedItems;
    if (typeof selectedItems !== 'undefined' && selectedItems.length > 0) {
      return true;
    } else return false;
  };

  const removeUrxFormContainer = () => {
    const style = window.document.getElementById(
      `${'urx-form-container'}`,
    ) as HTMLDivElement;
    if (style) {
      style.style.display = 'none';
    }
  };

  const handleReset = () => {
    if (step === 9) {
      removeUrxFormContainer();
    }
    reset();
    removeAWSButton();
    setDeluxeData(deluxeState);
    setDeluxePkg(false);
    setPackageOption(topMatch);
    setPlan('');
    setInvalidQ1(false);
    setInvalidQ2(false);
    setInvalidQ3(false);
    setInvalidQ4(false);
    setInvalidQ5(false);
    setInvalidQ6(false);
    setInvalidQ7(false);
    setInvalidQ8(false);
  };

  const handleSegmentTracking = (cta: string) => {
    segmentsTracking('CTA Clicked', {
      pageTitle: 'MaaS360 Plan Assessment',
      object: 'Mass360 page',
      resultValue: 'CTA clicked',
      CTA: cta,
      location: 'Assessment',
      action: '',
      field: '',
    });
  };

  const handleTopMatchData = (topMatchName: string) => {
    const title =
      topMatchName === 'Enterprise'
        ? convertToString(useTranslation('enterprise_title', true))
        : topMatchName === 'Premier'
        ? convertToString(useTranslation('premier_title', true))
        : topMatchName === 'Essentials'
        ? convertToString(useTranslation('essentials_title', true))
        : convertToString(useTranslation('deluxe_title', true));
    const plan =
      topMatchName === 'Enterprise'
        ? convertToString(useTranslation('enterprise_plan', true))
        : topMatchName === 'Premier'
        ? convertToString(useTranslation('premier_plan', true))
        : topMatchName === 'Essentials'
        ? convertToString(useTranslation('essentials_plan', true))
        : convertToString(useTranslation('deluxe_plan', true));
    const shortDesc =
      topMatchName === 'Enterprise'
        ? convertToString(useTranslation('enterprise_short_desc', true))
        : topMatchName === 'Premier'
        ? convertToString(useTranslation('premier_short_desc', true))
        : topMatchName === 'Essentials'
        ? convertToString(useTranslation('essentials_short_desc', true))
        : convertToString(useTranslation('deluxe_short_desc', true));
    const desc =
      topMatchName === 'Enterprise'
        ? convertToString(useTranslation('enterprise_desc', true))
        : topMatchName === 'Premier'
        ? convertToString(useTranslation('premier_desc', true))
        : topMatchName === 'Essentials'
        ? convertToString(useTranslation('essentials_desc', true))
        : convertToString(useTranslation('deluxe_desc', true));
    const icon =
      topMatchName === 'Enterprise'
        ? convertToString(useTranslation('enterprise_icon', true))
        : topMatchName === 'Premier'
        ? convertToString(useTranslation('premier_icon', true))
        : topMatchName === 'Essentials'
        ? convertToString(useTranslation('essentials_icon', true))
        : convertToString(useTranslation('deluxe_icon', true));
    setTopMatchDetails({
      ...topMatchDetails,
      title,
      plan,
      shortDesc,
      desc,
      icon,
      signUpUrl: marketplaceUrl.signUp,
    });
  };

  useEffect(() => {
    if (topMatch) {
      handleTopMatchData(topMatch);
    }
  }, [topMatch, open]);

  const determineTopMatch = () => {
    const { Q2, Q3, Q4 } = trackQuesID;
    switch (true) {
      case Q4 === 'Q4A1':
        setTopMatch('Enterprise');
        setPlan('MaaS360 Enterprise');
        setDeluxe(false);
        setDeluxeData(deluxeState);
        setTopMatchDetails({
          ...topMatchDetails,
          price: enterprisePrice.toString(),
          url: marketplaceUrl.enterprise,
        });
        break;
      case Q3 === 'Q3A1':
        setTopMatch('Premier');
        setPlan('MaaS360 Premier');
        setDeluxe(false);
        setDeluxeData(deluxeState);
        setTopMatchDetails({
          ...topMatchDetails,
          price: premierPrice.toString(),
          url: marketplaceUrl.premier,
        });
        break;
      case (Q2 === 'Q2A1' && Q3 === 'Q3A2') || Q2 === 'Q2A1' || Q3 === 'Q3A2':
        setTopMatch('Essentials');
        setPlan('MaaS360 Essentials');
        setDeluxe(true);
        setTopMatchDetails({
          ...topMatchDetails,
          price: essentialPrice.toString(),
          url: marketplaceUrl.essential,
        });
        setDeluxeData({
          ...deluxeData,
          title: convertToString(useTranslation('deluxe_title', true)),
          shortDesc: convertToString(useTranslation('deluxe_short_desc', true)),
          plan: convertToString(useTranslation('deluxe_plan', true)),
          icon: convertToString(useTranslation('deluxe_icon', true)),
          price: deluxePrice.toString(),
          url: marketplaceUrl.deluxe,
        });
        break;
    }
  };

  const toggleInvalidPB = (
    answer: string,
    setInvalid: React.Dispatch<React.SetStateAction<boolean>>,
  ) => {
    if (answer === '') {
      setInvalid(true);
    } else {
      setInvalid(false);
    }
  };

  const previousStep = (prevStepNumber: number) => {
    setStep(prevStepNumber);
    handleSegmentTracking(`Moving back to question ${prevStepNumber}`);
  };

  const determineAWSButton = (
    currentStep: number,
    value: number,
    ans6: string,
    ans5: string,
  ) => {
    if (
      currentStep === 9 &&
      value >= DEVICE_THRESHOLD_AWS &&
      isMultipleOf(value, DEVICE_THRESHOLD_AWS) &&
      ans6 !== additionOption.opt2 &&
      ans5 === 'No'
    ) {
      addAWSButton();
    } else {
      removeAWSButton();
    }
  };

  const isMultipleOf = (value: number, multipleOf: number) => {
    return value % multipleOf === 0;
  };

  const addAWSButton = () => {
    if (!document.getElementById('aws')) {
      const buttons = document.querySelector('.bx--modal-footer');
      const button = document.createElement('button');
      button.className = 'bx--btn bx--btn--tertiary';
      button.textContent = convertToString(useTranslation('buy_now_aws', true));
      button.type = 'button';
      button.id = 'aws';
      button.addEventListener('click', () => {
        handleSegmentTracking('Buy Now on AWS');
        setTimeout(async () => {
          windowOpen(aws.url), 250;
        });
      });
      buttons?.insertBefore(button, buttons?.children[0].nextSibling);
    }
  };

  const removeAWSButton = () => {
    document.getElementById('aws')?.remove();
  };

  const validateStep = (step: number) => {
    switch (step) {
      case 1:
        setInvalidQ1(false);
        break;
      case 2:
        setInvalidQ2(false);
        break;
      case 3:
        setInvalidQ3(false);
        break;
      case 4:
        setInvalidQ4(false);
        break;
      case 5:
        setInvalidQ5(false);
        break;
      case 6:
        setInvalidQ6(false);
        break;
      case 7:
        setInvalidQ7(false);
        break;
      case 8:
        setInvalidQ8(false);
        break;
    }
  };

  const isBuyNowForIBM = (ans5: string, ans6: string, step: number) => {
    return ans5 === 'No' && ans6 === additionOption.opt3 && step === 9;
  };

  /* Reseting a question based on the answer of different question */
  const resetQuestion = (
    quesNum: string,
    answer: string,
    key: string,
    setQueValue: React.Dispatch<React.SetStateAction<string>>,
  ) => {
    if (answer === key) {
      setQueValue('');
      setTrackQuesID({
        ...trackQuesID,
        [quesNum]: '',
      });
    }
  };

  useEffect(() => {
    determineTopMatch();
    determineAWSButton(step, Number(que7Value), que6Value, que5Value);
    resetQuestion('Q2', que1Value, MaaS360.usecase1, setQue2Value);
    resetQuestion('Q3', que2Value, 'Yes', setQue3Value);
  }, [
    que1Value,
    que2Value,
    que3Value,
    que4Value,
    que5Value,
    que6Value,
    que7Value,
    open,
    step,
  ]);

  return (
    <div className="bx--grid">
      <Modal
        open={open}
        onRequestClose={handleCloseModal}
        primaryButtonText={
          isBuyNowForIBM(que5Value, que6Value, step)
            ? convertToString(useTranslation('buy_here_btn', true))
            : step === 8
            ? convertToString(useTranslation('results_button', true))
            : step === 9
            ? convertToString(useTranslation('order_text', true))
            : convertToString(useTranslation('next_btn', true))
        }
        secondaryButtonText={
          step > 1
            ? convertToString(useTranslation('back_btn', true))
            : convertToString(useTranslation('close_btn', true))
        }
        preventCloseOnClickOutside={true}
        primaryButtonDisabled={isRequired}
        onRequestSubmit={() => {
          validateStep(step);
          if (isBuyNowForIBM(que5Value, que6Value, step)) {
            handleSegmentTracking('Buy now on ibm.com');
            setTimeout(async () => {
              windowOpen(
                packageOption !== 'Deluxe'
                  ? topMatchDetails.url
                  : deluxeData.url,
              ),
                250;
            });
          } else if (step === 9) {
            handleUrxForm();
            handleSegmentTracking('Request a Quote');
            const q5value = que8Value.multi.selectedItems
              .map((item) => item['cookieText'])
              .join(' + ');
            const ans = [
              `Q1:${que1Value}`,
              `Q2:${que2Value}`,
              `Q3:${que3Value}`,
              `Q4:${que4Value}`,
              `Q5:${que5Value}`,
              `Q6:${que6Value}`,
              `Q7:${que7Value}`,
              `Q8:${q5value}`,
            ];
            const match = !deluxePkg ? plan : DELUX_MATCH;
            useSetCookie(match, ans, cookieURL);
          } else if (step === 1 && trackQuesID.Q1 === 'Q1A1') {
            setStep((step) => step + 2);
            setInvalidQ2(true);
          } else if (step === 2 && trackQuesID.Q2 === 'Q2A1') {
            setStep((step) => step + 2);
            setInvalidQ3(true);
          } else {
            setStep((step) => step + 1);
            if (
              !que1Value ||
              !que4Value ||
              !que5Value ||
              !que6Value ||
              !que7Value ||
              !checkQ8Value(que8Value)
            ) {
              setIsRequired(true);
            }
            handleSegmentTracking(
              que8Value.multi.selectedItems.length > 0
                ? `all question answered`
                : `question ${step} answered - moving to question ${step + 1}`,
            );
          }
        }}
        size="lg"
        onSecondarySubmit={() => {
          if (step === 9) {
            handleSegmentTracking('Back');
            setStep((step) => step - 1);
            removeUrxFormContainer();
            removeAWSButton();
          } else {
            if (invalidQ2 && step === 3) {
              previousStep(1);
              setInvalidQ2(false);
            } else if (invalidQ3 && step === 4) {
              previousStep(2);
              setInvalidQ3(false);
            } else if (step > 1) {
              previousStep(step - 1);
              setIsRequired(false);
            } else {
              handleCloseModal();
              handleSegmentTracking('Closed assessement from modal');
              setStep(1);
            }
          }
        }}
      >
        <div className="bx--row">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
            {bpName ? (
              <BusinessPartner bpName={bpName} logo={logo} urxForm={true} />
            ) : null}
          </div>
        </div>
        <div className="bx--row mt-02">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
            <ProgressIndicator
              spaceEqually={true}
              currentIndex={step - 1}
              onChange={(e) => {
                toggleInvalidPB(que1Value, setInvalidQ1);
                toggleInvalidPB(que2Value, setInvalidQ2);
                toggleInvalidPB(que3Value, setInvalidQ3);
                toggleInvalidPB(que4Value, setInvalidQ4);
                toggleInvalidPB(que5Value, setInvalidQ5);
                toggleInvalidPB(que6Value, setInvalidQ6);
                toggleInvalidPB(
                  que7Value === 0 ? '' : que7Value.toString(),
                  setInvalidQ7,
                );
                toggleInvalidPB(
                  que8Value.multi.selectedItems.length === 0
                    ? ''
                    : que8Value.multi.selectedItems
                        .map((obj) => obj.text)
                        .join(','),
                  setInvalidQ8,
                );
                setStep(e + 1);
                handleSegmentTracking(`question ${e + 1} clicked`);
              }}
              vertical={isSmall}
            >
              <ProgressStep label="1" invalid={invalidQ1} />
              <ProgressStep
                label="2"
                invalid={invalidQ2 && trackQuesID.Q1 !== 'Q1A1'}
                disabled={trackQuesID.Q1 === 'Q1A1'}
              />
              <ProgressStep
                label="3"
                invalid={invalidQ3 && trackQuesID.Q2 !== 'Q2A1'}
                disabled={trackQuesID.Q2 === 'Q2A1'}
              />
              <ProgressStep label="4" invalid={invalidQ4} />
              <ProgressStep label="5" invalid={invalidQ5} />
              <ProgressStep label="6" invalid={invalidQ6} />
              <ProgressStep label="7" invalid={invalidQ7} />
              <ProgressStep label="8" invalid={invalidQ8} />
            </ProgressIndicator>
          </div>
        </div>
        <div className={isSmall ? 'bx--row' : 'bx--row mt-02'}>
          <div className="bx--col-lg-10 bx--col-md-8 bx--col-sm-4">
            <div className={isSmall ? '' : 'mt-02'}>
              {step === 1 && (
                <Step1
                  que1Value={que1Value}
                  setQue1Value={setQue1Value}
                  setIsRequired={setIsRequired}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                  useTranslation={useTranslation}
                />
              )}
              {step === 2 && (
                <Step2
                  que2Value={que2Value}
                  setQue2Value={setQue2Value}
                  setIsRequired={setIsRequired}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                  useTranslation={useTranslation}
                />
              )}
              {step === 3 && (
                <Step3
                  que3Value={que3Value}
                  setQue3Value={setQue3Value}
                  setIsRequired={setIsRequired}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                  useTranslation={useTranslation}
                />
              )}
              {step === 4 && (
                <Step4
                  que4Value={que4Value}
                  setQue4Value={setQue4Value}
                  setIsRequired={setIsRequired}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                  useTranslation={useTranslation}
                />
              )}
              {step === 5 && (
                <Step5
                  que5Value={que5Value}
                  setQue5Value={setQue5Value}
                  setIsRequired={setIsRequired}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                  setShowTopMatch={setShowTopMatch}
                  useTranslation={useTranslation}
                />
              )}
              {step === 6 && (
                <Step6
                  /* todo: https://github.ibm.com/MSC-Cloud/hc-widgets/issues/974 
                     Issue to enhance questions values handling
                  */
                  que3Value={que3Value}
                  que4Value={que4Value}
                  que5Value={que5Value}
                  que6Value={que6Value}
                  setQue6Value={setQue6Value}
                  setIsRequired={setIsRequired}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                  useTranslation={useTranslation}
                />
              )}
              {step === 7 && (
                <Step7
                  que7Value={que7Value}
                  setQue7Value={setQue7Value}
                  setIsRequired={setIsRequired}
                  useTranslation={useTranslation}
                />
              )}
              {step === 8 && (
                <Step8
                  que3Value={que3Value}
                  que4Value={que4Value}
                  que5Value={que5Value}
                  que6Value={que6Value}
                  que7Value={que7Value}
                  que8Value={que8Value}
                  setQue8Value={setQue8Value}
                  setIsRequired={setIsRequired}
                  checkboxState={!checkQ8Value(que8Value)}
                  useTranslation={useTranslation}
                />
              )}
              {step === 9 && (
                <>
                  <Result
                    data={topMatchDetails}
                    deluxe={deluxe}
                    deluxeData={deluxeData}
                    que5Value={que5Value}
                    que6Value={que6Value}
                    deluxePkg={deluxePkg}
                    useTranslation={useTranslation}
                  />
                  {/* remove false when business wants to have delux back */}
                  {false && deluxe && (
                    <div>
                      <span className="page_sub_heading_2">
                        {useTranslation('request_plan_text')}
                      </span>
                      <Switcher
                        packageOption={packageOption}
                        setPackageOption={setPackageOption}
                        deluxePkg={deluxePkg}
                        setDeluxePkg={setDeluxePkg}
                        topMatch={topMatch}
                        handleSegmentTracking={handleSegmentTracking}
                        useTranslation={useTranslation}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="bx--col-lg-6 bx--col-md-8 bx--col-sm-4">
            {que1Value && (
              <div className="results">
                <div className="reset-item" onClick={handleReset}>
                  <span>{useTranslation('start_over')}</span>
                  <Restart20 className="restart-icon" />
                </div>
                <div className="selection">
                  {useTranslation('your_selection')}
                </div>
                <ul>
                  {que1Value && (
                    <Selection
                      state={convertToString(
                        useTranslation('q1_selec_key', true),
                      )}
                      answer={que1Value}
                      quesID={trackQuesID.Q1}
                      useTranslation={useTranslation}
                    />
                  )}
                  {!invalidQ2 && que2Value && (
                    <Selection
                      state={convertToString(
                        useTranslation('q2_selec_key', true),
                      )}
                      answer={que2Value}
                      quesID={trackQuesID.Q2}
                      useTranslation={useTranslation}
                    />
                  )}
                  {!invalidQ3 && que3Value && (
                    <Selection
                      state={convertToString(
                        useTranslation('q3_selec_key', true),
                      )}
                      answer={que3Value}
                      quesID={trackQuesID.Q3}
                      useTranslation={useTranslation}
                    />
                  )}
                  {!invalidQ4 && que4Value && (
                    <Selection
                      state={convertToString(
                        useTranslation('q4_selec_key', true),
                      )}
                      answer={que4Value}
                      quesID={trackQuesID.Q4}
                      useTranslation={useTranslation}
                    />
                  )}
                  {!invalidQ5 && que5Value && (
                    <Selection
                      state={convertToString(
                        useTranslation('q5_selec_key', true),
                      )}
                      answer={que5Value}
                      quesID={trackQuesID.Q5}
                      useTranslation={useTranslation}
                    />
                  )}
                  {!invalidQ6 && que6Value && (
                    <Selection
                      state={convertToString(
                        useTranslation('q6_selec_key', true),
                      )}
                      answer={que6Value}
                      quesID={trackQuesID.Q6}
                      useTranslation={useTranslation}
                    />
                  )}
                  {que7Value > 0 && (
                    <Selection
                      state={convertToString(
                        useTranslation('q7_selec_key', true),
                      )}
                      answer={que7Value}
                      useTranslation={useTranslation}
                    />
                  )}
                  {checkQ8Value(que8Value) && (
                    <Selection
                      state={convertToString(
                        useTranslation('q8_selec_key', true),
                      )}
                      arrAns={que8Value.multi.selectedItems}
                      useTranslation={useTranslation}
                    />
                  )}
                </ul>
              </div>
            )}
            {topMatch && step < 9 ? (
              <TopMatch
                data={topMatchDetails}
                que5Value={que5Value}
                que6Value={que6Value}
                useTranslation={useTranslation}
              />
            ) : null}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Assessment;
